// Klient API teczki instalacji `/api/v1/teczka/` (backend: aplikacja `teczka`, 2026-10-23). Sesja w ciasteczku
// + CSRF, jak api/account.js. Teczka jest tylko dla konta prywatnego: jedna na konto, części `projekt`, `sprzet`,
// `pieniadze`, `miejsca` jako JSON, którego wnętrze ustala sesja danej części. Umowa o danych: repo VV,
// `zadania/2026-10_teczka-instalacji.md`. W komponentach zwykle wygodniej przez hooks/useTeczka.
import { apiFetch } from './apiFetch'

const BASE = process.env.REACT_APP_TECZKA_API_URL || '/api/v1/teczka'

const readCookie = (name) => {
  const m = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`))
  return m ? decodeURIComponent(m[2]) : null
}

const request = async (path, { method = 'GET', body } = {}) => {
  const headers = { 'Content-Type': 'application/json' }
  if (method !== 'GET') {
    const csrf = readCookie('csrftoken')
    if (csrf) headers['X-CSRFToken'] = csrf
  }
  let res
  try {
    res = await apiFetch(`${BASE}${path}`, {
      method, headers, credentials: 'same-origin', body: body ? JSON.stringify(body) : undefined,
    })
  } catch {
    return { ok: false, error: 'Brak połączenia z serwerem. Spróbuj ponownie.' }
  }
  let data = null
  try { data = await res.json() } catch { data = null }
  if (!res.ok) {
    return {
      ok: false, httpStatus: res.status, kod: data?.kod || null, data,
      error: (data && typeof data.detail === 'string' && data.detail) || 'Nie udało się zapisać teczki.',
    }
  }
  return { ok: true, data }
}

/** `{ teczka: null | { nazwa, projekt, sprzet, pieniadze, miejsca, utworzono, zmieniono, rysunek_pobrany_at },
 *  darmowy_projekt: 'dostepny' | 'zuzyty' | 'nie_dotyczy' }`. Konto firmowe: 403 `kod: konto_firmowe`. */
export const pobierzTeczke = () => request('/')

/** Zapis części: każda podana zastępowana w całości, niepodane zostają, `null` czyści. Pierwszy zapis zakłada
 *  teczkę. Odpowiedź jak `pobierzTeczke`. Inny budynek po zużyciu „raz” bez Premium: 402 (okno Premium otwiera
 *  api/apiFetch). */
export const zapiszCzesci = (czesci) => request('/', { method: 'PATCH', body: czesci })

/**
 * Pobranie pliku rysunku (PDF albo PNG) z Projektu 3D: wołaj PRZED zapisem pliku, przy każdym pobraniu.
 * Konto prywatne: zapisuje `projekt` w teczce i przy pierwszym razie zużywa „raz za darmo”. Konto firmowe: nic.
 * `mozna: false` tylko przy 402 (inny budynek bez Premium; okno Premium otwiera się samo). Błąd sieci albo serwera
 * nie blokuje pobrania, żeby nie karać użytkownika za naszą awarię.
 */
export const zglosPobranieRysunku = async ({ projekt } = {}) => {
  const w = await request('/rysunek-pobrany', { method: 'POST', body: projekt ? { projekt } : {} })
  return { ...w, mozna: w.ok || w.httpStatus !== 402 }
}

/** Co zobaczy wykonawca zaproszony do zlecenia z teczką (bez adresu, mapy, nazwy, PPE i ceny oferty): `{ teczka }`
 *  w odpowiedzi; 404 `{ teczka: null }`, gdy teczki jeszcze nie ma. Plan „VoltValue dla domu”, P5. */
export const pobierzPodgladWykonawcy = () => request('/podglad-wykonawcy')
